<template>
	<div :class="{'menu-container' : true ,  'is-open' : isOpen , 'ltr':sitelocale == 'en'  ? true : false }">
		<button class="slide-menu-button focus:outline-none" @click.prevent="toggleMenu" aria-label="toggle" >
			<span></span>
			<span></span>
			<span></span>
		</button>
		<div :class="{'slide-out-menu' : true ,   'is-open' : isOpen }">
			<slot name="top"></slot>
			
			<slot name="bottom"></slot>
		</div>
	</div>
</template>
<script>
	export default {
		name: "MobileMenu",
		props: {
			sitelocale:{
				type: String,
				required: true
			},
		},
		data() {
			return {
				isOpen: false,
			};
		},
		methods: {
			toggleMenu() {
				if(this.isOpen){
					this.isOpen = false;
					$('html').removeClass('overflow-hidden');
				}else{
					this.isOpen = true;
					$('html').addClass('overflow-hidden');
				}

			},

		},

	};
</script>




// WEBPACK FOOTER //
// resources/assets/js/front/components/GeneralComponents/MobileMenu.vue